import React, { forwardRef } from "react";
import { styled } from "goober";

import globals from "@/util/global-whitelist.mjs";

export const DROPSHADOW_OVERLAY_CSS =
  "filter: drop-shadow(0 var(--sp-0_5) var(--sp-2) var(--shade10-50));";

export function getEarlyComp(name, comps) {
  return Object.values(comps ?? {}).find(
    (i) => i?.compName?.toLowerCase() === name?.toLowerCase(),
  );
}

const sizes = {
  small: "calc(var(--sp-5) * 15)",
  medium: "calc(var(--sp-5) * 30)",
};
export const InGameBox = styled("div", forwardRef)`
  background-color: var(--shade9);
  border-radius: var(--br);
  position: relative;
  width: ${({ size }) => sizes[size] || "auto"};
`;

export const InGameContent = styled("div")`
  padding: var(--sp-4);
`;

const HighlightedChar = styled("span")`
  color: var(--shade0);
`;

export function StringToHighlight({ source, match }) {
  if (!match) {
    return <HighlightedChar>{source}</HighlightedChar>;
  }
  const regexp = new RegExp(match, "i");
  const idxStart = source.match(regexp)?.index;
  if (typeof idxStart === "undefined") {
    return <HighlightedChar>{source}</HighlightedChar>;
  }
  const idxEnd = idxStart + match.length;
  const split = [...source];
  const start = split.slice(0, idxStart).join("");
  const middle = split.slice(idxStart, idxEnd).join("");
  const end = split.slice(idxEnd, source.length).join("");
  return (
    <>
      {start}
      <HighlightedChar>{middle}</HighlightedChar>
      {end}
    </>
  );
}

export const autoScaleUp = () => {
  const { innerHeight } = globals;
  return innerHeight > 1080 ? innerHeight / 1080 : 1;
};
export const autoScale = () => {
  const { innerHeight } = globals;
  return innerHeight / 1080;
};
